/**
 * @internal true
 * @module briefing/BriefingHeader
 * Cabeçalho Hero premium com saudação dinâmica,
 * data e KPI pills resumindo o dia.
 */
import {
  CalendarDays, Users, AlertTriangle, CheckCircle2, Sparkles,
  GraduationCap, BookOpen, Building2
} from 'lucide-react';

interface BriefingHeaderProps {
  nomeUsuario: string;
  nomeEscola: string;
  saudacao: string;
  dataFormatada: string;
  perfil: string;
  cargo: string;
  /* KPIs de resumo */
  eventosHoje: number;
  incidentesAtivos: number;
  presentesHoje: number;
  totalAlunos: number;
  totalTurmas: number;
  pctPresenca: number;
  loading: boolean;
}

export function BriefingHeader({
  nomeUsuario,
  nomeEscola,
  saudacao,
  dataFormatada,
  perfil,
  eventosHoje,
  incidentesAtivos,
  presentesHoje,
  totalAlunos,
  totalTurmas,
  pctPresenca,
  loading,
}: BriefingHeaderProps) {
  const perfilLabel: Record<string, string> = {
    ADMIN: 'Painel Escola',
    ESCOLA: 'Painel Escola',
    MASTER: 'Comando Master',
    MUNICIPAL: 'Gestão Municipal',
    ESTADUAL: 'Gestão Estadual',
    PROFESSOR: 'Área do Professor',
    RESPONSAVEL: 'Área do Responsável',
    ALUNO: 'Área do Aluno',
  };

  return (
    <header className="brief-hero">
      <div className="brief-hero-badge">
        <Sparkles />
        {perfilLabel[perfil] || 'Aluno Conectado'} — Briefing Diário
      </div>
      <h1 className="brief-hero-title">
        {saudacao}, {nomeUsuario}! 👋
      </h1>
      <p className="brief-hero-meta">
        {dataFormatada}
        {nomeEscola && <> — <strong>{nomeEscola}</strong></>}
      </p>

      {!loading && (
        <div className="brief-hero-summary">
          <span className="brief-hero-pill">
            <CalendarDays />
            <span className="brief-hero-pill-val">{eventosHoje}</span>
            evento{eventosHoje !== 1 ? 's' : ''} hoje
          </span>

          {incidentesAtivos > 0 && (
            <span className="brief-hero-pill" style={{ borderColor: 'rgba(239,68,68,0.3)', background: 'rgba(239,68,68,0.15)' }}>
              <AlertTriangle />
              <span className="brief-hero-pill-val">{incidentesAtivos}</span>
              alerta{incidentesAtivos !== 1 ? 's' : ''} aberto{incidentesAtivos !== 1 ? 's' : ''}
            </span>
          )}

          {incidentesAtivos === 0 && (
            <span className="brief-hero-pill" style={{ borderColor: 'rgba(16,185,129,0.3)', background: 'rgba(16,185,129,0.15)' }}>
              <CheckCircle2 />
              Nenhum alerta
            </span>
          )}

          {totalAlunos > 0 && (
            <span className="brief-hero-pill">
              <GraduationCap />
              <span className="brief-hero-pill-val">{presentesHoje}</span>
              /{totalAlunos} presentes ({pctPresenca}%)
            </span>
          )}

          {totalTurmas > 0 && (
            <span className="brief-hero-pill">
              <BookOpen />
              <span className="brief-hero-pill-val">{totalTurmas}</span>
              turma{totalTurmas !== 1 ? 's' : ''}
            </span>
          )}
        </div>
      )}
    </header>
  );
}
